<template>
  <div v-if="list.length > 0"
       class="pay-center-require-field"
  >
    <div class="pay-center-require-field-header">
      <div class="pay-center-require-field-header-name">
        必填信息
      </div>
      <div class="pay-center-require-field-header-hint">
        *请{{ hint }}下方信息
      </div>
    </div>
    <ym-item v-for="key in list"
             :key="key"
             class="pay-center-require-field-item"
             :class="[
               { 'not-with-input': field[key].link }
             ]"
             :title="field[key].title"
             size="small"
             :strong-value="field[key].value !== ''"
             :is-link="field[key].link"
             @click="handleClickItem(key)"
    >
      <span class="pay-center-require-field-item-user-desc">
        {{ field[key].useDesc }}
      </span>
      <input v-if="!field[key].link"
             class="pay-center-require-field-item-input"
             v-model="field[key].value"
             :ref="key"
             type="text"
             :title="field[key].title"
             :placeholder="field[key].hint"
             @blur="handleBlur(key)"
      >
      <span v-else
            class="pay-center-require-field-item-input"
      >
        {{ field[key].value === '' ? field[key].hint : field[key].value }}
      </span>
    </ym-item>
  </div>
</template>

<script>
  import { setMyTrueName, setMyEmail } from '@/services/user';
  import validator from '@/utils/validator';
  import PayCenterItem from '@/pages/Pay/components/PayCenterItem';

  export default {
    name: 'PayCenterRequireField',
    components: {
      'ym-item': PayCenterItem,
    },
    props: {
      field: {
        type: Object,
        required: true,
      },
      link: {
        type: Boolean,
        default: false,
      },
      redirectTo: {
        type: String,
      },
      block: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      list() {
        return Object.keys(this.field).filter(key => this.field[key].show);
      },
      hint() {
        const filedValues = Object.keys(this.field).filter(key => this.field[key].value === '');
        return filedValues.length === 0 ? '确认' : '填写';
      },
    },
    methods: {
      handleClickItem(key) {
        if (key === 'mobile') {
          this.handleClickMobile();
          return;
        }
        this.$refs[key][0].focus();
      },
      handleClickMobile() {
        const { redirectTo, field: { mobile } } = this;
        if (mobile.value === '') {
          const route = {
            name: 'BindMobile',
            query: { redirectTo },
          };
          this.$router.push(route);
          return;
        }
        const route = {
          name: 'ModifyMobile',
          query: { redirectTo },
        };
        this.$router.push(route);
      },
      handleBlur(key) {
        if (key === 'trueName') {
          this.handleFillTrueName();
          return;
        }
        if (key === 'email') {
          this.handleFillEmail();
        }
      },
      async handleFillTrueName() {
        const { value: trueName } = this.field.trueName;
        if (validator.isEmpty(trueName)) {
          this.$toast('请填写孩子姓名');
          return;
        }
        await setMyTrueName(trueName);
      },
      async handleFillEmail() {
        const { value: email } = this.field.email;
        if (!validator.isEmail(email)) {
          this.$toast('请填写正确的电子邮箱');
          return;
        }
        await setMyEmail(email);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .pay-center-require-field {
    margin: @size-small 0;
    padding: @size-base @size-base (@size-base - @size-extra-small/2);
    background: @color-white;

    &-header {
      display: flex;
      align-items: center;
      margin-bottom: @size-base - @size-extra-small/2;

      &-name {
        font-size: @font-size-medium;
      }

      &-hint {
        margin-left: @size-small;
        font-size: @font-size-small;
        color: @color-text-highlight;
      }
    }

    &-item {
      &.not-with-input {
        padding: @size-base/2 0;
      }

      &-user-desc {
        color: @color-text-lighter;
        font-size: @font-size-small;
        line-height: 1;
      }

      &-input {
        flex: 1;
        padding: @size-base/2 0;
        text-align: right;
        outline: none;
        color: @color-text-light;
      }
    }
  }
</style>
